var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRepeatRight = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14C2.77333 14 3 13.7737 3 13.5004V5.28711C3 4.46044 3.55993 3.78711 4.3866 3.78711H13.6133C13.8866 3.78711 14.1133 3.56044 14.1133 3.28711C14.1133 3.01378 13.8866 2.78711 13.6133 2.78711H4.3866C3.0066 2.78711 2 3.90711 2 5.28711V13.5004C2 13.7804 2.22667 14 2.5 14Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5066 6.04665C11.6333 6.04665 11.7599 5.99996 11.8599 5.89996L13.9666 3.79332C14.0599 3.69998 14.1133 3.5733 14.1133 3.43996C14.1133 3.30663 14.0599 3.17998 13.9666 3.08665L11.8599 0.979961C11.6666 0.786628 11.3466 0.786628 11.1533 0.979961C10.9599 1.17329 10.9599 1.49333 11.1533 1.68667L12.9066 3.43996L11.1533 5.1933C10.9599 5.38663 10.9599 5.70663 11.1533 5.89996C11.2533 5.9933 11.3799 6.04665 11.5066 6.04665Z",
    fill: "#757575"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRepeatRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/repeat-right.f4168989.svg";
export { ForwardRef as ReactComponent };